import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Dropdown, MenuItem} from 'react-bootstrap';

import {getMessage} from './../../utils/i18n';
import {getUserProperty} from './../../utils/userProfile';
import defaultAvatar from './../../resources/images/default-avatar.png';
import {postLogout} from "../../utils/postLoginLogout";

class Utils extends Component {

    handleSelect(eventKey) {
        const component = this;
        ({
            changePassword() {
                component.props.history.push(`/changePassword`);
            },
            changeLanguage() {
                component.props.history.push(`/changeLanguage`);
            },
            logout() {
                postLogout();
            },
        })[eventKey]();
    };

    render() {
        return (
            <ul className="foUtils">
                <li className="foUtilsUser">
                    <Dropdown pullRight id="foMenuDropdown" onSelect={this.handleSelect.bind(this)}>
                        <Dropdown.Toggle bsStyle={'link'}>
                            <img className="foUtilsUserAvatar" src={getUserProperty('avatar') || defaultAvatar} alt=""/>
                            <span className="foUtilsUserName">
                                {getUserProperty('fullName') || getUserProperty('userName') || getUserProperty('username') || getUserProperty('email')}
                            </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <MenuItem eventKey="changePassword">{getMessage('app.action.change-password')}</MenuItem>
                            <MenuItem eventKey="changeLanguage">{getMessage('app.action.change-language')}</MenuItem>
                            <MenuItem eventKey="logout">{getMessage('app.action.logout')}</MenuItem>
                        </Dropdown.Menu>
                    </Dropdown>
                </li>
            </ul>
        );
    };

}

export default withRouter(Utils);


// WEBPACK FOOTER //
// ./src/app/components/header/utils.js